<template>
  <div :style="canvasStyle">
    <div class="page-background" :style="backgroundImageStyle">
      <div class="page-content" :style="pageStyle">
        <component
          v-for="item in pageConfig.componentConfig"
          :id="item.id"
          :key="item.id"
          :is="item.component"
          :cid="item.componentId"
          :tags="item.tags"
          :uid="item.id"
          :uname="item.name"
          :ref="item.id"
          :styles="item.styles"
          :configuration-data="item.configurationData"
          :interval-data-fetch-list="item.intervalDataFetchList"
          :events="item.events"
          @component-event-emitted="handleComponentEvents(arguments, item.id)"
          @defined-event-emitted="handleDefinedEvents"
        >
          <template v-for="(value, name) in item.childrenSlots" #[name]>
            <template v-for="child in value">
              <component
                :id="child.id"
                :key="child.id"
                :is="child.component"
                :cid="child.componentId"
                :tags="child.tags"
                :uid="child.id"
                :uname="child.name"
                :ref="child.id"
                :styles="child.styles"
                :configuration-data="child.configurationData"
                :interval-data-fetch-list="child.intervalDataFetchList"
                :events="child.events"
                @component-event-emitted="handleComponentEvents(arguments, child.id)"
                @defined-event-emitted="handleDefinedEvents"
              />
            </template>
          </template>
        </component>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@tencent/ceiba-ui/ui-mixin';

const constant = {
  // 屏幕
  SCREEN_WIDTH: typeof document !== 'undefined' ? document.documentElement.clientWidth : 0,
  SCREEN_HEIGHT: typeof document !== 'undefined' ? document.documentElement.clientHeight : 0,
  // PC设计稿背景图
  PC_DESIGN_BG_WIDTH: 1920,
  PC_DESIGN_BG_HEIGHT: 1080,
  // PC居中编辑区域
  PC_DESIGN_WIDTH: 1366,
  PC_DESIGN_HEIGHT: 768,
};

export default {
  name: 'CPagePc',
  mixins: [mixin],
  data() {
    return {};
  },
  computed: {
    // 页面分辨率
    resolution() {
      const { resolution = '1366*768' } = this.pageConfig.canvasConfig;

      const [width] = this.actInfo.config.resolution.split('*');
      const arr = resolution.split('*');

      return {
        width,
        height: arr[1], // 0.7版本,高度自适应,
      };
    },
    // 分辨率样式
    resolutionStyle() {
      return {
        width: `${this.resolution.width}px`,
        height: `${this.resolution.height}px`,
      };
    },
    canvasStyle() {
      let backgroundColor = '#ffffff';
      if (constant.SCREEN_WIDTH > constant.PC_DESIGN_BG_WIDTH) {
        backgroundColor = this.pageConfig.canvasConfig.background || '#ffffff';
      }
      return {
        backgroundColor,
      };
    },
    // 页面样式，目前仅包含 width height backgroundColor
    pageStyle() {
      return {
        ...this.resolutionStyle,
        margin: '0px auto',
      };
    },
    backgroundImageStyle() {
      const { backgroundImage } = this.pageConfig.canvasConfig || {};
      if (!backgroundImage) {
        return {};
      }
      return {
        backgroundImage: `url(${backgroundImage.src})`,
        backgroundSize: backgroundImage.equalScale ? 'auto 100%' : '100%',
        backgroundSize: '1920px', // 写死背景图宽度
        backgroundPosition: '50% 0',
        minWidth: `${this.resolution.width}px`,
        maxWidth: '1920px',
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@tencent/ceiba-base-components/index.scss';
@import './styles.scss';

.page-background {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;

  .page-content {
    position: relative;
  }
}
</style>
